import { render, staticRenderFns } from "./StartseiteNews.vue?vue&type=template&id=7146fcfa"
import script from "./StartseiteNews.vue?vue&type=script&lang=js"
export * from "./StartseiteNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports